import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {MappedTagInfo} from '../../shared/types';

export const StationTagsActions = createActionGroup({
  source: "[Station Tags]",
  events: {
    Search: props<{stationUid: string}>(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ data: Array<MappedTagInfo>}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

